import { SpinnerLegacy } from "../../../components";
import { RouteTabbedList } from "../../../components/navigationTabs/RouteTabbedList";
import { useBuyerOrderList } from "../../../hooks/api/v2/order/useBuyerOrderList";
import { BuyerAllOrdersList } from "./AllOrders/BuyerAllOrdersList";
import { BuyerActionRequiredOrderList } from "./RequestedOrders/BuyerActionRequiredOrderList";
import { OrdersListMenu } from "./AllOrders/AllOrdersList";
import { useOrderListTabSelection } from "./useOrderListTabSelection";

export const BuyerOrdersListTabs = ({
  selectedOrderId,
}: {
  selectedOrderId: number | null;
}) => {
  // Same query as in orderRequested tab - used to say whther to set initial tab
  // as all orders or requested orders
  const query = useBuyerOrderList({
    limit: 20,
    query: [
      {
        type: "requiredAction",
        modifier: "EQUALS",
        value: true,
      },
      {
        type: "cancelledAt",
        modifier: "IS_NULL",
      },
      {
        type: "deniedAt",
        modifier: "IS_NULL",
      },
    ],
  });

  const actionableOrdersLength = query.data?.pages[0]?.length;
  const actionableOrdersCount =
    (actionableOrdersLength ?? 0) >= 10
      ? "10+"
      : (actionableOrdersLength ?? 0).toString();
  const hasOrdersToAction = !!actionableOrdersLength;
  const { getTabUrl, selectedTabName } = useOrderListTabSelection({
    attentionTabName: "Action required",
    defaultTab: hasOrdersToAction ? "Action required" : "All orders",
    enabled: !query.isPending,
  });

  if (query.isPending) return <SpinnerLegacy />;

  return (
    <RouteTabbedList
      ariaLabel="Order views"
      headerContent={
        selectedTabName === "All orders" ? <OrdersListMenu /> : null
      }
      selectedTab={selectedTabName}
      tabs={[
        {
          label: `Action required (${actionableOrdersCount})`,
          name: "Action required",
          panel: (
            <BuyerActionRequiredOrderList selectedOrderId={selectedOrderId} />
          ),
          to: getTabUrl("Action required"),
        },
        {
          label: "All orders",
          name: "All orders",
          panel: <BuyerAllOrdersList selectedOrderId={selectedOrderId} />,
          to: getTabUrl("All orders"),
        },
      ]}
    />
  );
};
